import React, { VoidFunctionComponent } from "react";
import { getProductTitle } from "@/utils/responsive/utils";

interface Props {
    frontLabel: string,
    title: string,
    markLabel: string,
    type: string,
}

export const Title: VoidFunctionComponent<Props> = ({ frontLabel, title, markLabel, type }) => (
    <h1 className="product-title block-layout">
        {getProductTitle(frontLabel, title, markLabel, type)}
    </h1>
)